import { createTheme } from '@mui/material/styles';
import { varColor, varFont } from '~/themes/themeVariables';
import { inputsCustomizations } from '~/themes/muiCustomizations/inputs';

/**
 * All components of MUI following this theme
 */
export const customTheme = createTheme({
  typography: {
    fontFamily: varFont.primary,
    fontSize: 14,
    allVariants: {
      lineHeight: 'normal',
    },
    button: {
      textTransform: 'none',
      fontSize: 14,
    },
  },

  palette: {
    primary: {
      light: varColor.primary,
      main: varColor.primary,
      dark: varColor.primary,
      contrastText: varColor.white,
    },
    secondary: {
      light: varColor.secondary,
      main: varColor.secondary,
      dark: varColor.secondary,
      contrastText: varColor.black,
    },
    info: {
      light: varColor.info,
      main: varColor.info,
      dark: varColor.info,
      contrastText: varColor.white,
    },
    error: {
      light: varColor.error,
      main: varColor.error,
      dark: varColor.error,
      contrastText: varColor.white,
    },
    text: {
      primary: varColor.textPrimary,
      secondary: varColor.textSecondary,
    },
    divider: varColor.dividerPrimary,
  },

  components: {
    ...inputsCustomizations,
  },
});
